import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';
import { ManualMeasure } from '../types/measure.interface';
import { isMeasureNameUniqueAcrossEntities } from '../utils/measure-name-uniqueness.util';

export const manualMeasureDefinition: EntityDefinition<ManualMeasure> = {
  entityType: 'Measure',
  i18nBase: 'entities.manualMeasure',
  list: { columns: [] },
  fields: [
    { field: 'name', labelKey: 'common.labels.name', required: true, type: 'text', minLength: 3, maxLength: 50 },
    {
      field: 'locationIds',
      labelKey: 'entities.manualMeasure.fields.locationIds',
      required: false,
      type: 'multi',
      storeType: 'Location',
    },
    { field: 'description', labelKey: 'common.labels.description', required: false, type: 'textarea' },
    { field: 'priority', labelKey: 'common.labels.mandatory', required: false, type: 'boolean' },
    { field: 'assetId', labelKey: 'entities.manualMeasure.fields.assetId', type: 'hidden', required: true },
  ],
  validationRules: [
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: ManualMeasure, store) => (store ? isMeasureNameUniqueAcrossEntities(entity, store, 'ManualMeasure') : true),
      errorMessageKey: 'entities.manualMeasure.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
    },
  },
  formOptions: {
    showDeleteButton: false,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.manualMeasure.messages.createTitle',
      edit: () => 'entities.manualMeasure.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.manualMeasure.messages.addButton',
      create: () => 'entities.manualMeasure.messages.addButton',
      edit: () => 'entities.manualMeasure.messages.editTitleWithName',
      delete: () => 'entities.manualMeasure.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.manualMeasure.messages.deleteConfirm',
  },
  enableFiltering: true,
};
